import { ISelectItem } from "@/types";
import { IAttachment } from "@/types/attachment";
import { IUser } from "@/types/user";
import { Attachment } from "./attachment";

export class User implements IUser {
  public id = 0;
  public name = "";
  public kana = "";
  public nickname = "";
  public email = "";
  public tel = "";
  public password = "";
  public abilities = "";
  public role = 0;
  public created_at = "";
  public updated_at = "";
  public deleted_at = "";

  public attachment: IAttachment = new Attachment();

  public constructor(props?: IUser) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
    if (props.image) {
      this.attachment = new Attachment(props.image);
    }
  }

  public static toSelectItem(user: IUser): ISelectItem {
    return {
      text: user.name,
      value: user.id,
    };
  }
}
